const sanitizeError = (error, context = {}) => ({
  name: error?.name || 'Error',
  message: error?.message || 'Unknown application error',
  component: context.component || 'unknown',
  route: typeof window !== 'undefined' ? window.location.pathname : '',
  buildVersion: context.buildVersion || '',
  occurredAt: new Date().toISOString(),
});

export const reportOperationalError = (error, context = {}) => {
  const detail = sanitizeError(error, context);
  console.error('[operational-error]', detail);
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('jury:operational-error', { detail }));
  }
  return detail;
};

export default reportOperationalError;
